import React from 'react';

/**
 * Lightweight “AI assistant” presence: abstract face that animates while Aria’s voice plays.
 * No external assets — pure CSS/SVG so it works offline and in Electron.
 */
function AriaSpeakingAvatar({ speaking, className = '' }) {
  return (
    <div
      className={`aria-speaking-avatar ${speaking ? 'aria-speaking-avatar--speaking' : ''} ${className}`.trim()}
      aria-hidden
    >
      <div className="aria-speaking-avatar__ring" />
      <svg className="aria-speaking-avatar__svg" viewBox="0 0 120 120" role="img" aria-label="">
        <defs>
          <linearGradient id="aria-avatar-skin" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#d1fae5" />
            <stop offset="55%" stopColor="var(--accent-hover)" />
            <stop offset="100%" stopColor="var(--accent)" />
          </linearGradient>
          <linearGradient id="aria-avatar-hair" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#064e3b" />
            <stop offset="100%" stopColor="#022c22" />
          </linearGradient>
        </defs>
        {/* Hair */}
        <path
          className="aria-speaking-avatar__hair"
          fill="url(#aria-avatar-hair)"
          d="M60 18c-22 0-38 14-40 36 0 8 2 16 6 22 4-10 14-18 34-18s30 8 34 18c4-6 6-14 6-22-2-22-18-36-40-36z"
        />
        {/* Face */}
        <ellipse cx="60" cy="62" rx="34" ry="38" fill="url(#aria-avatar-skin)" />
        {/* Eyes */}
        <ellipse className="aria-speaking-avatar__eye" cx="44" cy="58" rx="5" ry="6" fill="#022c22" />
        <ellipse className="aria-speaking-avatar__eye" cx="76" cy="58" rx="5" ry="6" fill="#022c22" />
        {/* Mouth — scales when speaking */}
        <path
          className="aria-speaking-avatar__mouth"
          fill="#16a34a"
          d="M46 78c6 10 22 10 28 0-8 6-20 6-28 0z"
        />
      </svg>
    </div>
  );
}

export default React.memo(AriaSpeakingAvatar);
